var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import React from 'react';
import IconLineUp from '../../../icons/icon-line-up';
import CardTotal from '../../components/card-total';
import { fetchReportUserMonthly, fetchReportUserRegister } from '../../../cores/api/api-dashboard';
import { formatUserWithLabel } from '../../../utils/utils';
/** Number + compound label (購入ユーザー / いいねユーザー), same size */
const NUM = 'text-3xl font-semibold tabular-nums';
const LABEL_COMPOUND = 'text-3xl font-semibold ml-2';
/** Total count + 「ユーザー」: same size for digit(s) and label */
const TOTAL_PX = 'text-[20px] leading-[20px] font-semibold';
const TOTAL_NUM = `${TOTAL_PX} tabular-nums shrink-0`;
const TOTAL_LABEL = `${TOTAL_PX} ml-2`;
function CountWithCompoundLabel({ value, label }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "min-w-0 max-w-full overflow-x-auto overflow-y-hidden"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-flex max-w-none flex-nowrap items-baseline whitespace-nowrap"
    }, /*#__PURE__*/ React.createElement("span", {
        className: `${NUM} shrink-0`
    }, value), /*#__PURE__*/ React.createElement("span", {
        className: LABEL_COMPOUND
    }, label)));
}
/**
 * Keep "count + ユーザー" on one line; parent may use horizontal scroll if the number is very long
 * so the card layout does not break.
 */
function TotalWithUserLabel({ value }) {
    return /*#__PURE__*/ React.createElement("span", {
        className: "inline-flex flex-nowrap items-baseline whitespace-nowrap"
    }, /*#__PURE__*/ React.createElement("span", {
        className: TOTAL_NUM
    }, value), /*#__PURE__*/ React.createElement("span", {
        className: TOTAL_LABEL
    }, "\u30E6\u30FC\u30B6\u30FC"));
}
/**
 * "/" + total. From sm: cap width (~50%) so the 購入/いいね column keeps space; from md: no cap.
 * Inner wrapper still uses overflow-x for extremely large counts.
 */
function SlashAndTotal({ value }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex min-w-0 shrink items-baseline gap-x-2 sm:max-w-[50%] md:max-w-none"
    }, /*#__PURE__*/ React.createElement("span", {
        className: `min-w-[1.25rem] shrink-0 self-center ${TOTAL_PX} text-center leading-none text-gray-400`,
        "aria-hidden": true
    }, "/"), /*#__PURE__*/ React.createElement("div", {
        className: "min-w-0 max-w-full overflow-x-auto overflow-y-hidden sm:[scrollbar-width:thin]"
    }, /*#__PURE__*/ React.createElement(TotalWithUserLabel, {
        value: value
    })));
}
const MIN_STATS_YEAR = 2021;
function sumYearRegistrationTotals(rows) {
    return rows.reduce((acc, r) => {
        var _a, _b, _c;
        return ({
            total: acc.total + ((_a = r.total_users) !== null && _a !== void 0 ? _a : 0),
            plan: acc.plan + ((_b = r.purchase_plan_users) !== null && _b !== void 0 ? _b : 0),
            like: acc.like + ((_c = r.purchase_like_users) !== null && _c !== void 0 ? _c : 0)
        });
    }, {
        total: 0,
        plan: 0,
        like: 0
    });
}
function yoyPercent(currentTotal, previousTotal) {
    if (previousTotal > 0) {
        return Math.round((currentTotal - previousTotal) / previousTotal * 10000) / 100;
    }
    return currentTotal > 0 ? 100 : 0;
}
export default function SectionUserDayWeekMonth({ gender, params }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const _useQuery = useQuery({
        queryKey: ['sectionUserDayWeekMonth', gender, params.mode, params.year, params.mode === 'month' ? (_a = params.month) !== null && _a !== void 0 ? _a : dayjs().month() + 1 : null],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const chartGender = gender === 1 ? 'male' : gender === 2 ? 'female' : undefined;
            if (params.mode === 'month') {
                const month = (_a = params.month) !== null && _a !== void 0 ? _a : dayjs().month() + 1;
                const reg = yield fetchReportUserRegister({
                    gender,
                    year: params.year,
                    month
                });
                const monthCard = (_b = reg.data.month_request) !== null && _b !== void 0 ? _b : reg.data.this_month;
                return {
                    periods: reg.data,
                    monthCard,
                    yearCard: null
                };
            }
            const _await$Promise$all = yield Promise.all([fetchReportUserRegister({
                    gender
                }), fetchReportUserMonthly(_objectSpread(_objectSpread({
                    year: params.year
                }, chartGender ? {
                    gender: chartGender
                } : {}), {}, {
                    sort_by: 'month',
                    order: 'asc'
                }))]), _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2), periods = _await$Promise$all2[0], curMonthly = _await$Promise$all2[1];
            const totals = sumYearRegistrationTotals(curMonthly.data);
            let changePercent = 0;
            if (params.year > MIN_STATS_YEAR) {
                const prevMonthly = yield fetchReportUserMonthly(_objectSpread(_objectSpread({
                    year: params.year - 1
                }, chartGender ? {
                    gender: chartGender
                } : {}), {}, {
                    sort_by: 'month',
                    order: 'asc'
                }));
                const prevTotals = sumYearRegistrationTotals(prevMonthly.data);
                changePercent = yoyPercent(totals.total, prevTotals.total);
            }
            const yearCard = {
                total: totals.total,
                purchase_plan_users: totals.plan,
                purchase_like_users: totals.like,
                change_percent: changePercent
            };
            return {
                periods: periods.data,
                monthCard: null,
                yearCard
            };
        }),
        suspense: true
    }), data = _useQuery.data;
    const monthOnly = (_b = params.month) !== null && _b !== void 0 ? _b : dayjs().month() + 1;
    const isThisCalendarMonth = params.mode === 'month' && params.year === dayjs().year() && monthOnly === dayjs().month() + 1;
    // 月モードのときだけ「YYYY年M月」。年モード（および month 以外）は「YYYY年」のみ（月は dayjs の今月で誤表示しない）
    const firstTitle = params.mode === 'month' ? isThisCalendarMonth ? '今月' : `${params.year}年${monthOnly}月` : `${params.year}年`;
    const firstCard = params.mode === 'year' ? data === null || data === void 0 ? void 0 : data.yearCard : (_c = data === null || data === void 0 ? void 0 : data.monthCard) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.periods.this_month;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-4 lg:col-span-1"
    }, /*#__PURE__*/ React.createElement(CardTotal, {
        title: firstTitle,
        total: /*#__PURE__*/ React.createElement("div", {
            className: "flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-x-4"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex min-w-0 flex-1 flex-col gap-1"
        }, /*#__PURE__*/ React.createElement(CountWithCompoundLabel, {
            value: (_d = firstCard === null || firstCard === void 0 ? void 0 : firstCard.purchase_plan_users) !== null && _d !== void 0 ? _d : 0,
            label: "\u8CFC\u5165\u30E6\u30FC\u30B6\u30FC"
        }), /*#__PURE__*/ React.createElement(CountWithCompoundLabel, {
            value: (_e = firstCard === null || firstCard === void 0 ? void 0 : firstCard.purchase_like_users) !== null && _e !== void 0 ? _e : 0,
            label: "\u3044\u3044\u306D\u30E6\u30FC\u30B6\u30FC"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "flex w-full justify-end sm:w-auto sm:justify-end"
        }, /*#__PURE__*/ React.createElement(SlashAndTotal, {
            value: (_f = firstCard === null || firstCard === void 0 ? void 0 : firstCard.total) !== null && _f !== void 0 ? _f : 0
        }))),
        growthTitle: "\u30E6\u30FC\u30B6\u30FC",
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null),
        isDown: ((_g = firstCard === null || firstCard === void 0 ? void 0 : firstCard.change_percent) !== null && _g !== void 0 ? _g : 0) < 0,
        change_percent: (_h = firstCard === null || firstCard === void 0 ? void 0 : firstCard.change_percent) !== null && _h !== void 0 ? _h : 0
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u4ECA\u9031",
        total: /*#__PURE__*/ React.createElement("span", {
            className: "flex items-center gap-2"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "text-3xl font-semibold"
        }, formatUserWithLabel({
            value: (_k = (_j = data === null || data === void 0 ? void 0 : data.periods.this_week) === null || _j === void 0 ? void 0 : _j.purchased_users) !== null && _k !== void 0 ? _k : 0,
            label: '購入ユーザー'
        })), /*#__PURE__*/ React.createElement("span", {
            className: "text-gray-400 text-4xl"
        }, "/"), /*#__PURE__*/ React.createElement("span", {
            className: "text-3xl font-semibold"
        }, formatUserWithLabel({
            value: (_m = (_l = data === null || data === void 0 ? void 0 : data.periods.this_week) === null || _l === void 0 ? void 0 : _l.total) !== null && _m !== void 0 ? _m : 0,
            label: 'ユーザー'
        }))),
        growthTitle: "\u30E6\u30FC\u30B6\u30FC",
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null),
        isDown: ((_o = data === null || data === void 0 ? void 0 : data.periods.this_week.change_percent) !== null && _o !== void 0 ? _o : 0) < 0,
        change_percent: (_p = data === null || data === void 0 ? void 0 : data.periods.this_week.change_percent) !== null && _p !== void 0 ? _p : 0
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u4ECA\u65E5",
        total: /*#__PURE__*/ React.createElement("span", {
            className: "flex items-center gap-2"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "text-3xl font-semibold"
        }, formatUserWithLabel({
            value: (_r = (_q = data === null || data === void 0 ? void 0 : data.periods.today) === null || _q === void 0 ? void 0 : _q.purchased_users) !== null && _r !== void 0 ? _r : 0,
            label: '購入ユーザー'
        })), /*#__PURE__*/ React.createElement("span", {
            className: "text-gray-400 text-4xl"
        }, "/"), /*#__PURE__*/ React.createElement("span", {
            className: "text-3xl font-semibold"
        }, formatUserWithLabel({
            value: (_t = (_s = data === null || data === void 0 ? void 0 : data.periods.today) === null || _s === void 0 ? void 0 : _s.total) !== null && _t !== void 0 ? _t : 0,
            label: 'ユーザー'
        }))),
        growthTitle: "\u30E6\u30FC\u30B6\u30FC",
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null),
        isDown: ((_u = data === null || data === void 0 ? void 0 : data.periods.today.change_percent) !== null && _u !== void 0 ? _u : 0) < 0,
        change_percent: (_v = data === null || data === void 0 ? void 0 : data.periods.today.change_percent) !== null && _v !== void 0 ? _v : 0
    }));
}
